import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTextField } from '@react-aria/textfield';
import { Fragment, forwardRef, useCallback, useRef } from 'react';
import { isBoolean, isFormValidationErrorDisplayed } from '../../common.types.js';
import { RequiredAsterisk, InputLabel, InputWrapper, TextInput, InputErrorMessage, IconTextInputWrapper, } from './BKJDollarTextInput.styled.js';
import { mergeRefs } from '../BKJSelect/utils/mergeRefs.js';
export const BKJDollarTextInput = forwardRef((props, ref) => {
    const { label, error, disabled, required, className, onChange, value, max, ...rest } = props;
    const innerRef = useRef({});
    const handleOuterFocus = useCallback(() => {
        innerRef.current?.focus();
    }, []);
    const handleBlur = useCallback((e) => {
        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        let val = Number.parseFloat(e.target.value.replace(/[^0-9.-]+/g, ''));
        let maskedValue = '';
        if (e.target.value !== '' && !Number.isNaN(val)) {
            if (max)
                val = Math.min(val, max);
            maskedValue = currencyFormatter.format(val);
        }
        if (onChange) {
            onChange({ ...e, target: { value: maskedValue } });
        }
    }, [onChange, max]);
    const handleChange = useCallback((e) => {
        if (onChange) {
            onChange({ ...e, target: { value: e.target.value } });
        }
    }, [onChange]);
    const hasStringyError = isFormValidationErrorDisplayed(error) && !isBoolean(error);
    const { labelProps, inputProps, errorMessageProps } = useTextField({
        isRequired: required,
        isDisabled: disabled,
        label: label || 'Dollar amount',
        value,
        errorMessage: hasStringyError ? error : undefined,
        validationState: isFormValidationErrorDisplayed(error) ? 'invalid' : 'valid',
        onBlur: handleBlur,
    }, innerRef);
    const hasValue = value !== '';
    return (_jsxs(IconTextInputWrapper, { className: className, tabIndex: -1, onFocus: handleOuterFocus, children: [label && (_jsxs(InputLabel, { ...labelProps, disabled: disabled, children: [label, required && _jsx(RequiredAsterisk, { children: "\u00A0*" })] })), _jsx(InputWrapper, { children: _jsx(TextInput, { ...inputProps, placeholder: "None", ref: mergeRefs([innerRef, ref]), error: error ? (Array.isArray(error) ? !!error.length : !!error) : false, disabled: disabled, value: value, hasValue: hasValue, onChange: handleChange, max: max, inputMode: "decimal", ...rest }) }), hasStringyError && (_jsx(InputErrorMessage, { ...errorMessageProps, children: Array.isArray(error)
                    ? error.map((err, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx("br", {}), err] }, `${err}-${i}`)))
                    : error }))] }));
});
//# sourceMappingURL=BKJDollarTextInput.js.map